import { useBoolean } from 'react-use'

import { FileCategory } from '@makyoapp/makyo-sdk/models/Files'

import constate from '@/lib/constate'

export enum FileManagerKind {
  Upload = 'upload',
  FileUrl = 'fileUrl',
  MyFiles = 'myFiles',
}

export type FileManagerChangeHandler = (ty: FileManagerKind, value: unknown) => void

export interface FileManagerNavLabelProps {
  upload?: string
  fileUrl?: string
  myFiles?: string
}

export interface FileManagerProviderProps {
  id?: string
  show?: boolean
  onHide?: () => void
  title?: string
  onChange: FileManagerChangeHandler
  navLabels?: FileManagerNavLabelProps
  maxHeight?: string
  forceUrlPanelHeight?: boolean
  gridCols?: number
  fileTypes?: FileCategory[]
  hideImagesByDefault?: boolean
  showHideImageToggle?: boolean
}

const [FileManagerProvider, useFileManagerContext] = constate(
  'FileManagerContext',
  (props: FileManagerProviderProps) => {
    const [hideImage, setHideImage] = useBoolean(!!props.hideImagesByDefault)

    return {
      ...props,
      hideImage,
      setHideImage,
    }
  }
)

export { FileManagerProvider, useFileManagerContext }
